import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AoiToolComponent } from "../aoi-tool/aoi-tool.component";
import * as calcite from 'calcite-web/es6';
import { Config } from '../Config';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements AfterViewInit {
  @ViewChild('aoiToolWindow', { static: false }) private aoiToolWindowRef: ElementRef<any>;
  @ViewChild('aoiTool', { static: false }) private aoiTool: AoiToolComponent;
  @ViewChild('measureToolsWindow', { static: false }) private measureToolsWindowRef: ElementRef<any>;
  @ViewChild('distance', { static: false }) private distanceRef: ElementRef<any>;
  @ViewChild('tabs', { static: false }) private tabsRef: ElementRef<any>;
  @ViewChild('area', { static: false }) private areaRef: ElementRef<any>;
  @ViewChild('coordinates', { static: false }) private coordinatesRef: ElementRef<any>;
  @ViewChild('routing', { static: false }) private routingRef: ElementRef<any>;
  @ViewChild('auth', { static: false }) private pdauthRef: ElementRef<any>;
  @ViewChild('bookmarkWindow', { static: false }) private bookmarkWindowRef: ElementRef<any>;
  @ViewChild('bookmark', { static: false }) private bookmarkRef: ElementRef<any>;
  @ViewChild('userSettingsWindow', { static: false }) private userSettingsWindowRef: ElementRef<any>;
  @ViewChild('userSettings', { static: false }) private userSettingsRef: ElementRef<any>;
  @ViewChild('aboutWindow', { static: false }) private aboutWindowRef: ElementRef<any>;
  @ViewChild('contactWindow', { static: false }) private contactWindowRef: ElementRef<any>;
  @ViewChild('helpWindow', { static: false }) private helpWindowRef: ElementRef<any>;
  @ViewChild('disclaimerWindow', { static: false }) private readonly disclaimerWindow: ElementRef<any>;
  @ViewChild('startupMessage', { static: false }) private readonly startupMessage: ElementRef<any>;
  @ViewChild('streetViewWindow', { static: false }) private streetViewWindowRef: ElementRef<any>;
  @ViewChild('streetView', { static: false }) private streetViewRef: ElementRef<any>;
  @ViewChild('rmsSelect', { static: false }) private rmsSelectRef: ElementRef<any>;
  @ViewChild('latLongSelect', { static: false }) private latLongSelectRef: ElementRef<any>;

  skipAOI: boolean = false;
  showStartupMessage: boolean = true;
  isInternal: boolean;
  isTouch: boolean = false;
  isIosOrSafari: boolean = false;
  @Output()
  updateIsInternal: EventEmitter<boolean> = new EventEmitter()
  
  public config = (window as any).config as Config;

  @Output()
  toggleKeyboard: EventEmitter<boolean> = new EventEmitter()
  openWindows: string[] = [];

  @Output()
  toggleMapClickable: EventEmitter<boolean> = new EventEmitter()

  @Input()
  rmsLinkParams: { cn: string, rt: string, seg: string };

  private closeAoiWindowSubscription: Subscription;
  @Input() closeAoiWindow: Observable<void>;

  private openStreetViewWindowSubscription: Subscription;
  @Input() openStreetViewWindow: Observable<{ lat: number; long: number; }>;

  @Output()
  updateLocationToAoi: EventEmitter<any> = new EventEmitter()

  navBarButtonState: boolean[] = [false, false, false, false];

  async ngAfterViewInit() {
    if (this.config) {
      this.isInternal = this.config.isInternal;
      this.updateIsInternal.emit(this.isInternal);

      if (this.isInternal) {
        var pdauthService = this.pdauthRef.nativeElement.PDAuthService;
        pdauthService.enableForcedLogin();

        if (this.showStartupMessage)
          this.showInitialDialog();
        else
          this.openAoiTool();
      } else {
        this.disclaimerWindow.nativeElement.open();
      }
    }

    this.aoiTool.done.subscribe(_ => this.closeAoiTool());
    calcite.dropdown();

    this.aoiToolWindowRef.nativeElement.addEventListener('openChange', open => {
      this.manageOpenWindows(open.detail, 'aoi');
    })
    this.bookmarkWindowRef.nativeElement.addEventListener('openChange', open => {
      this.manageOpenWindows(open.detail, 'bookmark');
    })
    this.measureToolsWindowRef.nativeElement.addEventListener('openChange', open => {
      this.manageOpenWindows(open.detail, 'measurement');

      if (!open.detail) {
        this.distanceRef.nativeElement.active = false;
        this.areaRef.nativeElement.active = false;
        this.coordinatesRef.nativeElement.active = false;
        this.routingRef.nativeElement.active = false;
      }

      this.toggleMapClickable.emit(!open.detail);
    })


    this.userSettingsRef.nativeElement.addEventListener('activeChange', isActive => {
      if (!isActive.detail) {
        this.userSettingsWindowRef.nativeElement.close();
      }
    })

    this.closeAoiWindowSubscription = this.closeAoiWindow.subscribe(() => {
      this.closeAoiTool();
      if (!this.isInternal) {
        this.skipAOI = true;
      }
    });

    this.openStreetViewWindowSubscription = this.openStreetViewWindow.subscribe((startPosition) => {
      this.openStreetView();
      setTimeout(() => {
        this.streetViewRef.nativeElement.lat = startPosition.lat;
        this.streetViewRef.nativeElement.long = startPosition.long;
        if (!this.isInternal) {
          this.skipAOI = true;
        } else {
          this.closeAoiTool();
        }
      }, 1000);
    });

    this.streetViewWindowRef.nativeElement.addEventListener('openChange', open => {
      this.streetViewRef.nativeElement.active = open.detail;
    });
    this.streetViewRef.nativeElement.addEventListener('positionChange', (position) => {
      this.latLongSelectRef.nativeElement.setAttribute('lat', position.detail.latitude);
      this.latLongSelectRef.nativeElement.setAttribute('long', position.detail.longitude);
      this.rmsSelectRef.nativeElement.position = position.detail;
    });
    this.rmsSelectRef.nativeElement.addEventListener('rmsChange', (rms) => {
      this.streetViewRef.nativeElement.setRms(rms.detail);
    });
    this.latLongSelectRef.nativeElement.addEventListener('latChange', (lat) => {
      this.streetViewRef.nativeElement.setAttribute('lat', lat.detail);
    });
    this.latLongSelectRef.nativeElement.addEventListener('longChange', (long) => {
      this.streetViewRef.nativeElement.setAttribute('long', long.detail);
    });

  }

  showInitialDialog() {
    this.isTouch = window.matchMedia('(pointer: coarse)').matches;
    this.isIosOrSafari = /iPhone;|iPad;|iPod touch;|CriOS\/|FxiOS\/|EdgiOS\//i.test(window.navigator.userAgent) // iOS/iPadOS
      || /^(?=.*Macintosh)(?=.*Safari\/).*/i.test(window.navigator.userAgent);                                  // macOS/iPad desktop

    if (this.isIosOrSafari) {
      this.startupMessage.nativeElement.open();
      return;
    }

    if (this.skipAOI)
      return;

    this.openAoiTool();
  }

  closeStartupMessage() {
    this.startupMessage.nativeElement.close();
    if (this.skipAOI) return;

    this.openAoiTool();
  }

  newAoi() {
    this.updateLocationToAoi.emit();
  }

  emitToggleKeyBoard() {
    this.toggleKeyboard.emit(!this.openWindows.length);
  }

  manageOpenWindows(open:boolean, name:string) {
    if (!open) {
      this.openWindows.splice(this.openWindows.findIndex(w => w === name), 1);
    } else {
      this.openWindows.push(name);
    }
    this.emitToggleKeyBoard();
  }

  openAoiTool() {
    this.aoiTool.activateTab();
    this.aoiToolWindowRef.nativeElement.open();
  }

  closeAoiTool() {
    this.aoiToolWindowRef.nativeElement.close();
  }

  openMeasureTools() {
    this.measureToolsWindowRef.nativeElement.open();
    this.tabsRef.nativeElement.activateTab('Distance');
    this.distanceRef.nativeElement.active = true;
  }

  print() {
    window.print();
  }

  onTabChanged(e) {
    const refs = {
      'Area': this.areaRef,
      'Coordinates': this.coordinatesRef,
      'Routing': this.routingRef,
      'Distance': this.distanceRef
    };
    for (const ref of Object.keys(refs)) {
      refs[ref].nativeElement.active = ref === e.detail.name;
    }
  }

  onWindowOpenChange(e) {
    if (!e.detail) {
      this.areaRef.nativeElement.active = false;
      this.distanceRef.nativeElement.active = false;
      this.coordinatesRef.nativeElement.active = false;
      this.routingRef.nativeElement.active = false;
    }
  }

  openBookmark() {
    this.bookmarkWindowRef.nativeElement.open();
    this.bookmarkRef.nativeElement.active = true;
  }

  onBookmarkClose(e) {
    if (!e.detail) {
      this.bookmarkRef.nativeElement.active = false;
    }
  }

  openUserSettings() {
    this.userSettingsWindowRef.nativeElement.open();
    this.userSettingsRef.nativeElement.active = true;
  }

  onUserSettingsClose(e) {
    if (!e.detail) {
      this.userSettingsRef.nativeElement.active = false;
    }
  }

  openAbout() {
    this.aboutWindowRef.nativeElement.open();
  }

  openContact() {
    this.contactWindowRef.nativeElement.open();
  }

  openHelp() {
    this.helpWindowRef.nativeElement.open();
  }

  openStreetView() {
    this.streetViewWindowRef.nativeElement.open();
  }

  closeDisclaimer(response: number) {
    if (response == 0) {
      window.location.replace("https://www.penndot.pa.gov/");
    } else if (response == 1) {
      this.disclaimerWindow.nativeElement.close();

      if (this.showStartupMessage) // Show startup message
        this.showInitialDialog();
      else if (!this.skipAOI)      // Exit messages, show tool
        this.openAoiTool();
    }
  }

  openRMSLink(siteName: string) {
    var url: URL;

    if (siteName === "oneMap") {
      url = new URL(this.config.oneMapUrl);
    } else if (siteName === "irow") {
      url = new URL(this.config.irowUrl);
    } else if (siteName === "isle") {
      url = new URL(this.config.isleUrl);
    } else if (siteName === "pavementHistory") {
      url = new URL(this.config.pavementHistoryUrl);
    } else if (siteName === "tire") {
      url = new URL(this.config.tireUrl);
    }

    url = this.rmsUrlAddParams(url);
    window.open(url.toString());
  }

  rmsUrlAddParams(url: URL) {
    var cn = this.rmsLinkParams.cn != null ? this.rmsLinkParams.cn : '';
    var rt = this.rmsLinkParams.rt != null ? this.rmsLinkParams.rt : '';
    var sg = this.rmsLinkParams.seg != null ? this.rmsLinkParams.seg : '';

    if (cn != '') url.searchParams.append('cn', cn);
    if (rt != '') url.searchParams.append('rt', rt);
    if (sg != '') url.searchParams.append('sg', sg);

    return url;
  }

  get rmsSnippet() {
    if (this.rmsLinkParams) {
      const rms = this.rmsLinkParams;
      const parts = [rms.cn, rms.rt, rms.seg].filter(x => x);
      return `: ${parts.join(' | ')}`;
    }
    return '';
  }

  buttonFocusHandler(btnNumber: number) {
    let state = this.navBarButtonState[btnNumber];
    if (state) {
      this.navBarButtonState[btnNumber] = false;
      let navBtn = document.getElementById("navBtn" + btnNumber.toString());
      navBtn.blur();
    } else {
      for (let i = 0; i < this.navBarButtonState.length; i++) {
        this.navBarButtonState[i] = (i == btnNumber);
      }
    }
  }
}
